import { useRef, memo } from 'react';
import { cn, memoClassNames } from '@/utils';
import { Spinner } from '../icons';
import { useMermaid } from './use-mermaid';
import { Slot } from '@radix-ui/react-slot';

const classes = memoClassNames('Mermaid', ['root']);

export type MermaidProps = React.ComponentProps<'div'> & {
  children?: string;
  def?: string;
  asChild?: boolean;
};

export const Mermaid = memo(
  ({ className, def, children = def, asChild, ...others }: MermaidProps) => {
    const Comp = asChild ? Slot : 'div';
    const nodeRef = useRef(null);

    const defValue = !children ? '' : children;

    const [chartId, state] = useMermaid(defValue, nodeRef);

    return (
      <Comp
        {...others}
        data-mermaid={chartId}
        data-state={state}
        ref={nodeRef}
        className={cn(
          classes.root,
          'mm:relative mm:p-8 mm:bg-mindmap mm:text-mindmap-foreground',
          className
        )}
      >
        {state === 'loading' && <Spinner />}
      </Comp>
    );
  }
);
